import { create } from 'zustand';
import { IFactFindProcessStore, IFactFindProcessStoreSection } from './types';

export const useFactFindProcessStore = create<IFactFindProcessStore>((set) => ({
  sections: [] as IFactFindProcessStoreSection[],
  updateFactFindProcessDetails: (x: IFactFindProcessStoreSection[]) => set(() => ({ sections: x })),
}));

export default useFactFindProcessStore;
